import { Route, Switch } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css'; // bootstrap css

import AboutPage from './pages/About.js';
import ArchiveContent from './components/layout/Archive/ArchiveContentPost';
import ArchivePage from './pages/Archive';
import CollectionContent from './components/layout/Collection/CollectionContent';
import CollectionPage from './pages/Collection.js';
import HomePage from './pages/Home.js';
import PortfolioPage from './pages/Portfolio';

import Layout from './components/layout/Layout.js';


function App() {
  return (
    <Layout>
      <Switch>
				<Route path="/collection/:filename" component={CollectionContent} />
				<Route path="/archive/:filename" component={ArchiveContent} />

        <Route path='/' exact>
          <HomePage />
        </Route>

        <Route path='/collection'>
          <CollectionPage />
        </Route>
				
				<Route path='/archive'>
          <ArchivePage />
        </Route>

        <Route path='/about'>
          <AboutPage />
        </Route>

				<Route path='/portfolio'>
          <PortfolioPage />
        </Route>

				<Route path="/" element={<HomePage />} />
      </Switch>
    </Layout>
  );
}

export default App;